'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _RotateLeftOutlined = _interopRequireDefault(require('./lib/icons/RotateLeftOutlined'));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

var _default = _RotateLeftOutlined;
exports.default = _default;
module.exports = _default;